interface StationNameSource {
  description?: unknown
  controller?:
    | string
    | {
        name?: unknown
      }
    | null
}

const trimmedString = (value: unknown) =>
  typeof value === 'string' ? value.trim() : ''

export const resolveStationName = ({
  description,
  controller,
}: StationNameSource) => {
  const storedName = trimmedString(description)
  if (storedName) return storedName

  return trimmedString(
    typeof controller === 'string' ? controller : controller?.name,
  )
}
